import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { ApiCallError } from "web_myplann/Infrastructure/Api/ApiUtils";
import {
	getApiUrl,
	getChatViewImageIdPath,
} from "web_myplann/Infrastructure/ApiOld/Api";
import type { SessionState } from "web_myplann/Shared/State/sessionAtom";
import { createAuthorizationHeaders } from "web_myplann/Shared/Utils/createAuthorizationHeaders";

export const fetchChatAttachmentImage = async (
	attachmentId: number,
	session: SessionState,
): Promise<Blob> => {
	const url = `${getApiUrl()}${getChatViewImageIdPath(attachmentId)}`;
	const options: RequestInit = {
		headers: createAuthorizationHeaders(session),
	};

	const response = await fetch(url, options).catch(() => null);

	if (!response?.ok) {
		throw new ApiCallError(
			`Chat attachment image ${attachmentId} could not be loaded`,
			{
				data: null,
				error: new Error(response?.statusText ?? "Network error"),
				status: 0,
				args: { url, options },
			},
			{ skipToastFor: true },
			ChatKeys.attachmentImage(attachmentId),
		);
	}

	return response.blob();
};
